import React, { ChangeEvent, useEffect, useState } from 'react'
import './share.css'
import { Form, Modal, Spinner } from 'react-bootstrap'
import closeIcon from '../../assets/close.svg'
import CustomButton from '../CustomButton/CustomButton'
import { getDetails, postDetails } from '../../services/http/http.service'
import APIList from '../../utils/constants/APIList'
import { APIResponseCodes } from '../../utils/constants/keys.constants'
import { hideLoader, showLoader } from '../../store/Loader/loader.slice'
import { useAppDispatch } from '../../store/storeRequests'
import encrypt from '../../utils/helpers/encrypt'
import { message } from '../../utils/constants/Messages'

const Share: React.FunctionComponent<{ callback?: () => void, show: boolean, id: string, route: string, apiGroupName?: string }> = ({ callback, show=false, id, route='api', apiGroupName='' }) => {
    
    const dispatch = useAppDispatch()

    const [showShareModal, setShowShareModal] = useState(false)
    const [users, setUsers] = useState([] as Array<any>)
    const [selectedUsers, setSelectedUsers] = useState([] as Array<string>)
    const [isLoading, setIsLoading] = useState(true)
    const [selectedAll, setSelectedAll] = useState(false)

    const getUsers = async() => {
        const response = await getDetails(APIList.GET_ALL_USERS, getUsers)
        if (response.statusCode == APIResponseCodes.SUCCESS) {
            setUsers(response.data)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        setShowShareModal(show)
        if (show) {
            getUsers()
        }
    }, [show])

    /** Close modal : Executes callback function if passed via component props*/
    const closeModal = () => {
        if (typeof callback === 'function') {
            callback()
        }
        setShowShareModal(false)
        setUsers([])
        setSelectedUsers([])
        setIsLoading(true)
        setSelectedAll(false)
    }

    /** Push the selected emails if input checked
     *  Remove the email if input unchecked
     */
    const onCheck = (ev: ChangeEvent<HTMLInputElement>, email: string) => {
        if (ev.target.checked) {
            setSelectedUsers([...selectedUsers, email])

            if ([...selectedUsers, email].length === users.length) {
                setSelectedAll(true)   
            }
        } else {
            let temp = selectedUsers.filter(id => id !== email)
            setSelectedUsers(temp)

            if (temp.length === 0) {
                setSelectedAll(false)
            }

        }
    }

    const postShare = async () => {

        dispatch(showLoader(message.SHARING))
        const payload = {
            shareLink: `${window.location.origin}/${route}/${encodeURIComponent(encrypt(id))}`,
            email: selectedUsers,
            apiGroupName
        }
        const response = await postDetails(APIList.SHARE_TO_USERS, payload, postShare)
        dispatch(hideLoader())
        if (response.statusCode === APIResponseCodes.SUCCESS) {
            closeModal()
        }
    }

    const selectAll = (didSelectAll: boolean) => {
        setSelectedAll(didSelectAll)
        const temp: Array<any> = []
        document.querySelectorAll('.share-user-checkbox').forEach((item: any) => {
            item.firstElementChild.checked = didSelectAll ? true : false
        })

        if (didSelectAll) {
            users.forEach(user => temp.push(user?.email))
            setSelectedUsers(temp)
        } else {
            setSelectedUsers([])
        }
    }
    
  return (
    <Modal show={showShareModal} className='mf-share' centered>
        <Modal.Header className='justify-content-center mf-central-modal-header border-0 position-relative'>
            <div className="cursor-pointer mf-modal-close" onClick={closeModal}>
                <img width="25" height="25" src={closeIcon} alt="close" />
            </div>
            <Modal.Title className='text-sec-color'><strong>Share API</strong></Modal.Title>
        </Modal.Header>
        {
            !isLoading &&
            <Modal.Body>
                <div className="d-flex justify-content-between align-items-center">
                    {
                        users.length !== 0 && 
                        <p className="mb-0 font-14 text-capitalize weight-500 text-primary-color">{ selectedUsers.length } <span className='font-13 weight-400'>users selected</span></p>
                    }
                    {
                        users.length !== 0 && 
                        <button onClick={() => selectAll(!selectedAll)} className='mb-0 font-13 px-2 py-1 text-white primary-bg-color text-capitalize weight-500 text-primary-color border-0 rounded' type='button'>{ selectedAll ? 'Unselect all' : 'select all'}</button>
                    }
                </div>
                <div className="share-profile-list mt-3 px-3 py-2 custom-scrollbar">
                    {
                        users.length !== 0 && users.map((user, index) => (
                            <div key={index} className="d-flex align-items-center share-user-item">
                                <Form.Check onChange={(ev) => onCheck(ev,user.email)} className='share-user-checkbox'/>
                                <p className="mb-0 primary-text-color font-14 ms-2">{ user.email }</p>
                            </div>        
                        ))
                    }
                    
                    {
                        users.length === 0 && 
                        <div className="d-flex align-items-center share-user-item justify-content-center">
                            <p className="weight-500 font-13 text-primary-color mt-2 mb-2">No users available...</p>
                        </div> 
                    }
                    
                    
                </div>
                {
                    users.length !== 0 &&
                    <div className="share-modal-btn mt-4 mb-2">
                        <CustomButton onClick={postShare} disabled={ users.length === 0 || selectedUsers.length === 0}>Share</CustomButton>
                    </div>
                }
            </Modal.Body>
        }
        {
            isLoading &&
            <Modal.Body>
                <div className="d-flex align-items-center share-loader-container justify-content-center py-2">
                    <Spinner className='text-sec-color' size='sm'></Spinner>
                    <p className="weight-500 font-13 text-sec-color mt-2 mb-2 ms-2">Getting all users...</p>
                </div> 
            </Modal.Body>
        }
    </Modal>
  )
}

export default Share